import { useEffect } from 'react';
import { EDU_CANONICAL_BASE } from '../../../config/appBase';

/**
 * pathbuddy.com/insights moved to IVORI Edu's General insights. Kept articles
 * go to their new page; retired ones go to the closest page that remains.
 */
const PATHBUDDY_INSIGHT_TARGETS = {
  'study-guide': '/insights/general/study-guide',
  'reasoning-education': '/insights/general/reasoning-education',
  'problem-solving': '/insights/general/problem-solving',
  'independent-school-stretch': '/insights/general/stretch-and-challenge',
  'scholarship-interviews': '/insights/general/live-interviews',
  'tutoring-vs-drills': '/insights/general/drills-vs-tutoring',
  'parents-guide': '/insights/general/parents-guide',
  'critical-thinking': '/insights/general/reasoning-education',
  'selective-schools': '/insights/general',
  'mistake-review': '/insights/general/problem-solving',
  readiness: '/insights/general',
  'pathbuddy-method': '/method',
};

export const PATHBUDDY_INSIGHTS_HOME = `${EDU_CANONICAL_BASE}/insights/general`;

export function pathbuddyInsightTarget(slug) {
  if (typeof slug === 'string' && Object.prototype.hasOwnProperty.call(PATHBUDDY_INSIGHT_TARGETS, slug)) {
    return `${EDU_CANONICAL_BASE}${PATHBUDDY_INSIGHT_TARGETS[slug]}`;
  }
  return PATHBUDDY_INSIGHTS_HOME;
}

export function ExternalRedirect({ href }) {
  useEffect(() => {
    window.location.replace(href);
  }, [href]);
  return <div aria-busy="true" />;
}
